wbApp.controller('CourseStudentFluctuationCtrl', ['$scope', '$translate', 'reportsSvc', 'localStorageService', 'semesterSvc',
function ($scope, $translate, reportsSvc, localStorageService, semesterSvc) {

    $scope.fromSemesterID = null;
    $scope.toSemesterID = null;
    $scope.include = {
        includeNew: true,
        includeLeaving: true
    };
    $scope.fluctuationType = 0;
    $scope.data = [];

    var sankeyInstance = null;

    var dataSource = new DevExpress.data.DataSource({
        load: function (loadOptions) {
            return $scope.data.$promise;
        },
        byKey: function (e) {
        },
        loadMode: 'processed'
    });

    $scope.resizableOptions = {
        handles: 'bottom',
        onResizeEnd: function (e) {
            if (sankeyInstance) {
                sankeyInstance.render();
            }
        }
    }

    $scope.sankeyOptions = {
        dataSource: dataSource,
        sourceField: "from",
        targetField: "to",
        weightField: "studentCount",
        title: "",
        //export: {
        //    enabled: true
        //},
        node: {
            width: 10,
            padding: 15
        },
        label: {
            customizeText: function (info) {

                var weightOut = _.sumBy(info.linksOut, 'weight');
                var weightIn = _.sumBy(info.linksIn, 'weight');

                if (weightOut != 0) {
                    return '(' + weightOut + ') ' + info.title;
                }

                return info.title + ' (' + weightIn + ')';
            }
        },
        margin: {
            left: 10,
            right: 0
        },
        link: {
            colorMode: "source"
        },
        tooltip: {
            enabled: true,
            zIndex: 2000,
            customizeLinkTooltip: function (info) {

                var allLeftCounts = _.sumBy(_.filter($scope.data, { 'from': info.source }), 'studentCount');
                var percent = Math.round((100 / allLeftCounts * info.weight) * 100) / 100;

                if ($scope.fluctuationType == 1) {
                    // Teachers

                    return {
                        html:
                            "<b>" + $translate.instant('TXT_TEACHER_FROM') + ":</b> " +
                            info.source +
                            "<br/><b>" + $translate.instant('TXT_TEACHER_TO') + ":</b> " +
                            info.target +
                            "<br/>" +
                            "<b>" + $translate.instant('TXT_NO_OF_STUDENTS') + ":</b> " +
                            info.weight + ' (' + percent + '%)'
                    };
                } else {
                    // Others

                    return {
                        html:
                            "<b>" + $translate.instant('TXT_CLASSROOM_FROM') + ":</b> " +
                            info.source +
                            "<br/><b>" + $translate.instant('TXT_CLASSROOM_TO') + ":</b> " +
                            info.target +
                            "<br/>" +
                            "<b>" + $translate.instant('TXT_NO_OF_STUDENTS') + ":</b> " +
                            info.weight + ' (' + percent + '%)'
                    };
                }


            },
            customizeNodeTooltip: function (info) {
                return {
                    html:
                        "<b>" + info.title + "</b> " +                        
                        "<br/>" + $translate.instant('TXT_NO_OF_STUDENTS') + ": " +
                        (info.weightIn != 0
                            ? info.weightIn 
                            : info.weightOut)
                };
            }
        },
        onInitialized: function (e) {
            sankeyInstance = e.component;
            setTitle();
        }
    };

    if (localStorageService.isSupported) {
        $scope.fromSemesterID = localStorageService.get('courseStudentFluctuationFromSemesterID');
        $scope.toSemesterID = localStorageService.get('courseStudentFluctuationToSemesterID');
        $scope.fluctuationType = localStorageService.get('courseStudentFluctuationType') || 0;
        $scope.include.includeNew = localStorageService.get('courseStudentFluctuationIncludeNew') || true;
        $scope.include.includeLeaving = localStorageService.get('courseStudentFluctuationIncludeLeaving') || true;

        loadData();
    }

    if (!$scope.fromSemesterID) {
        semesterSvc.getDefaultAsync().then(function (data) {
            if (!!data) {
                $scope.fromSemesterID = data.id;
                $scope.toSemesterID = data.id;
                loadData();
            }
        });
    }

    $scope.onFromSemesterChange = function(semesterID) {
        if (localStorageService.isSupported) {
            localStorageService.set('courseStudentFluctuationFromSemesterID', semesterID);
        }
        loadData();
    }

    $scope.onToSemesterChange = function (semesterID) {
        if (localStorageService.isSupported) {
            localStorageService.set('courseStudentFluctuationToSemesterID', semesterID);
        }
        loadData();
    }

    $scope.onFluctuationTypeChange = function (type) {
        if (localStorageService.isSupported) {
            localStorageService.set('courseStudentFluctuationType', type);
        }
        setTitle();
        loadData();
    }

    $scope.onIncludeNewChange = function (value) {
        if (localStorageService.isSupported) {
            localStorageService.set('courseStudentFluctuationIncludeNew', value);
        }
        loadData();
    }

    $scope.onIncludeLeavingChange = function (value) {
        if (localStorageService.isSupported) {
            localStorageService.set('courseStudentFluctuationIncludeLeaving', value);
        }
        loadData();
    }

    function loadData() {
        if (!!$scope.fromSemesterID && 
            !!$scope.toSemesterID &&
            $scope.fromSemesterID != $scope.toSemesterID) {

            var newData = [];

            switch ($scope.fluctuationType) {
                case 0:
                    newData =
                        reportsSvc.courseStudentFluctuationOverall($scope.fromSemesterID, $scope.toSemesterID);
                    break;
                case 1:
                    newData =
                        reportsSvc.courseStudentFluctuationByTeacher($scope.fromSemesterID, $scope.toSemesterID, $scope.include.includeNew, $scope.include.includeLeaving);
                    break;
                case 2:
                    newData =
                        reportsSvc.courseStudentFluctuationByClassroom($scope.fromSemesterID, $scope.toSemesterID, $scope.include.includeNew, $scope.include.includeLeaving);
                    break;
                case 3:
                    newData =
                        reportsSvc.courseStudentFluctuationBySubject($scope.fromSemesterID, $scope.toSemesterID, $scope.include.includeNew, $scope.include.includeLeaving);
                    break;
            }

            $scope.data = newData;
            $scope.data.$promise.then(function (d) {
                setHeight(d);
            });
            dataSource.reload();
        }
    }

    function setTitle() {
        var newTitle = '';
        switch ($scope.fluctuationType) {
            case 0:
                newTitle = $translate.instant('TXT_COURSE_STUDENT_FLUCTUATION_OVERALL');
                break;
            case 1:
                newTitle = $translate.instant('TXT_COURSE_STUDENT_FLUCTUATION_BY_TEACHER');
                break;
            case 2:
                newTitle = $translate.instant('TXT_COURSE_STUDENT_FLUCTUATION_BY_CLASSROOM');
                break;
            case 3:
                newTitle = $translate.instant('TXT_COURSE_STUDENT_FLUCTUATION_BY_SUBJECT');
                break;
        }
        if (sankeyInstance) {
            sankeyInstance.option('title', $translate.instant('TXT_MENU_COURSE_STUDENT_FLUCTUATION') + ' - ' + newTitle);
        }
        if ($scope.gridSettings.gridInstance) {

            $scope.gridSettings.gridInstance.columnOption(0, { caption: ($scope.fluctuationType == 1
                    ? $translate.instant('TXT_TEACHER_FROM')
                    : $translate.instant('TXT_CLASSROOM_FROM')) });
            $scope.gridSettings.gridInstance.columnOption(1, { caption: ($scope.fluctuationType == 1
                    ? $translate.instant('TXT_TEACHER_TO')
                    : $translate.instant('TXT_CLASSROOM_TO')) });
        }
    }

    function setHeight(data) {
        var leftCount = _.uniq(_.map(data, 'from')).length;
        var rightCount = _.uniq(_.map(data, 'to')).length;

        var m = Math.max(leftCount, rightCount);

        if (sankeyInstance) {
            sankeyInstance.option('size.height', Math.max(350, 70 * m) + 50);
        }
    }


    $scope.gridSettings = {
        name: 'courseStudentFluctuation',
        pager: {
            showPageSizeSelector: true,
            visible: "false"
        },
        paging: { pageSize: 100 },
        columns: [
            {
                dataField: 'from',
                caption: $scope.fluctuationType == 1
                    ? $translate.instant('TXT_TEACHER_FROM')
                    : $translate.instant('TXT_CLASSROOM_FROM'),
                dataType: 'string'
            },
            {
                dataField: 'to',
                caption: $scope.fluctuationType == 1
                    ? $translate.instant('TXT_TEACHER_TO')
                    : $translate.instant('TXT_CLASSROOM_TO'),
                dataType: 'string'
            },
            { dataField: 'studentCount', caption: $translate.instant('TXT_NO_OF_STUDENTS'), dataType: 'number', width: '60px' },
        ],
    };
}]);
